<template>
  <div>
    <template v-for="(item, $index) in ruleList">
      <div class="panel-box" :key="$index + '_1'">
        <RuleEditListTypeItem ref="ruleEditListTypeItem" :ruleTypeItem="item" :ruleTypeItemIndex="$index" :uploadUrl="uploadUrl" />
      </div>
      <div class="eb-line" :key="$index + '_2'"></div>
    </template>
  </div>
</template>

<script>
import RuleEditListTypeItem from './ProjRuleEditListTypeItem';

export default {
  props: {
    ruleList: {
      type: Array,
      required: true
    },
    uploadUrl: {
      type: String,
      required: true
    }
  },
  components: {
    RuleEditListTypeItem
  },
  created() {
  },
  methods: {
    expandAll() {
      this.$refs.ruleEditListTypeItem.forEach(function(item) {
        item.isExpand = true;
      });
    },
    collapseAll() {
      this.$refs.ruleEditListTypeItem.forEach(function(item) {
        item.isExpand = false;
      });
    }
  }
};
</script>

<style>

</style>
